import { subcat_bikelanes_plus_routes } from '../mapDataSubcategories/subcat_bikelanes_plus_routes.const'
import { subcat_bikelanes_plus_surface_text } from '../mapDataSubcategories/subcat_bikelanes_plus_surface_text.const'
import { subcat_bikelanes_plus_width_text } from '../mapDataSubcategories/subcat_bikelanes_plus_width_text.const'
import { subcat_radinfra_bicycleParking } from '../mapDataSubcategories/subcat_radinfra_bicycleParking.const'
import { subcat_radinfra_bikelanes } from '../mapDataSubcategories/subcat_radinfra_bikelanes.const'
import { subcat_radinfra_campaigns } from '../mapDataSubcategories/subcat_radinfra_campaigns.const'
import { subcat_radinfra_currentness } from '../mapDataSubcategories/subcat_radinfra_currentness.const'
import { subcat_radinfra_lit_bikelanes } from '../mapDataSubcategories/subcat_radinfra_lit_bikelanes.const'
import { subcat_radinfra_oneway } from '../mapDataSubcategories/subcat_radinfra_oneway.const'
import { subcat_radinfra_smoothness } from '../mapDataSubcategories/subcat_radinfra_smoothness.const'
import { subcat_radinfra_trafficSigns } from '../mapDataSubcategories/subcat_radinfra_trafficSigns.const'
import { subcat_radinfra_width } from '../mapDataSubcategories/subcat_radinfra_width.const'
import type { StaticMapDataCategory } from '../types'

export const categoriesRadinfra: StaticMapDataCategory[] = [
  {
    id: 'radinfra_bikelanes',
    name: 'Radinfrastruktur',
    desc: 'Führungsform, Breite, RVA-Oberfläche',
    subcategories: [
      { ...subcat_radinfra_bikelanes, defaultStyle: 'default' },
      // // { id: 'bikelanesOneway', defaultStyle: 'default' },
      { ...subcat_bikelanes_plus_routes, defaultStyle: 'hidden' },
      // { ...subcat_bikelanes_plus_bikesuitability, defaultStyle: 'hidden' },
    ],
  },
  {
    id: 'radinfra_surface',
    name: 'Oberflächenqualität',
    desc: 'Material und Qualität des Belages',
    subcategories: [
      { ...subcat_radinfra_smoothness, defaultStyle: 'default' },
      {
        ...subcat_bikelanes_plus_surface_text,
        defaultStyle: 'hidden',
      },
    ],
  },
  {
    id: 'radinfra_lit',
    name: 'Beleuchtung',
    desc: 'Beleuchtung der Infrastruktur',
    // radinfra.de only shows RVA (`bikelanes`), like every other category here.
    // The roads, path classes and highway areas variants (`subcat_radinfra_lit_roads`,
    // `subcat_radinfra_lit_path_classes`, `subcat_radinfra_lit_highway_areas`) were added in
    // f911e4d92 and removed again; restore them from git history if we want them back.
    subcategories: [{ ...subcat_radinfra_lit_bikelanes, defaultStyle: 'default' }],
  },
  {
    id: 'radinfra_width',
    name: 'Breite',
    desc: 'Breite der Infrastruktur',
    subcategories: [
      { ...subcat_radinfra_width, defaultStyle: 'default' },
      {
        ...subcat_bikelanes_plus_width_text,
        defaultStyle: 'hidden',
      },
    ],
  },
  {
    id: 'radinfra_oneway',
    name: 'Verkehrsrichtung',
    desc: 'Einbahnstraße oder beidseitig befahrbar?',
    subcategories: [{ ...subcat_radinfra_oneway, defaultStyle: 'default' }],
  },
  {
    id: 'radinfra_trafficSigns',
    name: 'Verkehrszeichen',
    desc: 'Ausschilderung der Infrastruktur',
    subcategories: [{ ...subcat_radinfra_trafficSigns, defaultStyle: 'default' }],
  },
  {
    id: 'radinfra_bicycleParking',
    name: 'Fahrradparken',
    desc: 'Fehlt die Anzahl der Stellplätze?',
    subcategories: [{ ...subcat_radinfra_bicycleParking, defaultStyle: 'default' }],
  },
  {
    id: 'radinfra_currentness',
    name: 'Aktualität',
    desc: 'Was lange nicht geprüft wurde…',
    subcategories: [{ ...subcat_radinfra_currentness, defaultStyle: 'default' }],
  },
  {
    id: 'radinfra_campagins',
    name: 'Kampagnen',
    desc: 'Hier gibt es etwas zu tun…',
    subcategories: [{ ...subcat_radinfra_campaigns, defaultStyle: 'default' }],
  },
]
